// Admin (CMS) fields left empty fall back to the page's built-in defaults,
// field by field. A list from the admin replaces the default list as a whole.
export default function fillDefaults(value, fallback) {
  if (value == null || value === "") return fallback;
  if (Array.isArray(value)) return value.length ? value : fallback;
  if (typeof value === "object" && fallback && typeof fallback === "object" && !Array.isArray(fallback)) {
    const out = { ...fallback };
    for (const k of Object.keys(value)) out[k] = fillDefaults(value[k], fallback[k]);
    return out;
  }
  return value;
}

// "Leave a blank line between paragraphs" → array of paragraphs
export const paragraphs = (text = "") => text.split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean);
